import React, { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "@/page-components/RightRecommendation/right-recommendation.module.css";
import config from "@/config";
import { useIndividualBarGraph } from "@/services/rightRecommendation/get-recommendation-individual-graph.repo";
import downlaodVM from "@/assets/img/downloadVM.svg";
import { OverlayTrigger, Tooltip as ReactTooltip } from "react-bootstrap";
import VerticalBarGraph from "@/components/States/verticalBarErrorState";
import ScenariosErrorState from "@/components/States/scenariosErrorState";
import { UseIndividualAllCloudDownload } from "@/services/rightRecommendation/get-download-individual-all-cloud.repo";
import CurrencyFormatter from "@/lib/value-converison";

const RecommendationsIndvidualBarGraph = ({
  service,
  data,
  isLoading,
  error,
}) => {
  const enabledClouds = Object.keys(data || {}).filter(
    (cloud) =>
      config.enabledClouds.has(cloud.toLowerCase()) && data[cloud]?.total > 0
  );

  const downloadQuery = useMemo(() => {
    const queryData = {
      service: "all-cloud",
    };

    return queryData;
  }, [service]);

  const { mutate: downloadMutate } =
    UseIndividualAllCloudDownload(downloadQuery);

  const handleDownloadClick = () => {
    downloadMutate(downloadQuery);
  };

  return (
    <div className={styles.container}>
      <div className={styles.download}>
        {((!isLoading && data) || error) && (
          <span className={styles.title}>Individual Cloud Recommendations</span>
        )}
        {!isLoading && !error && data && (
          <div className={styles.menu_icon_css1}>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <ReactTooltip id="tooltip">Download as CSV</ReactTooltip>
              }
            >
              <span
                className={styles.downloadButton}
                onClick={handleDownloadClick}
                data-testid="download-button"
              >
                <img src={downlaodVM} alt="" />
              </span>
            </OverlayTrigger>
          </div>
        )}
      </div>
      {isLoading && (
        <div
          className="container-fluid"
          style={{
            marginBottom: "7%",
            marginRight: "-12px",
            display: "flex",
            justifyContent: "start",
            gap: "20px",
            top: 16,
          }}
          data-testid="vertical-bar-graph"
        >
          {Array.from(config.enabledClouds).map((cloud, index) => (
            <VerticalBarGraph key={index} cloud={cloud} />
          ))}
        </div>
      )}
      {error && (
        <ScenariosErrorState error={error.message} messageConfig={{}} />
      )}
      {data && (
        <div className={styles.cards}>
          {enabledClouds.map((cloud) => {
            const { total, rightsizing, ri, savings, chartData } = data[cloud];
            return (
              <div key={cloud} className={styles.card}>
                <span className={styles.cardTitle}>
                  Active {cloud} Recommendations
                </span>
                <div className={styles.total_recomm}>
                  <span className={styles.total}>{total || 0}</span>
                  <span className={styles.recommendation_ri}>
                    Rightsizing {rightsizing || 0}
                  </span>{" "}
                  <span className={styles.recommendation_ri}>RI {ri || 0}</span>
                </div>
                <div className={styles.potential_saving}>
                  <span className={styles.savings}>Projected Savings</span>
                  <span className={styles.saving_value}>
                    <CurrencyFormatter value={savings} />
                  </span>
                </div>

                <ResponsiveContainer width="100%" height={120}>
                  <BarChart
                    layout="vertical"
                    data={chartData}
                    margin={{ top: 10, right: 20, left: 10, bottom: 0 }}
                  >
                    <XAxis
                      type="number"
                      tickLine={false}
                      axisLine={false}
                      fontSize={10}
                      fontFamily="Inter"
                      fontWeight={400}
                      stroke="#A3A3A3"
                    />
                    <YAxis
                      type="category"
                      dataKey="name"
                      tickLine={false}
                      axisLine={false}
                      fontSize={10}
                      fontFamily="Inter"
                      fontWeight={400}
                      stroke="#A3A3A3"
                    />

                    <Legend
                      align="start"
                      verticalAlign="bottom"
                      layout="horizontal"
                      iconSize={12}
                      iconType="Square"
                      fontSize={12}
                      fontWeight={400}
                      fontStyle="normal"
                      wrapperStyle={{ marginLeft: "60px" }}
                    />
                    <Bar
                      dataKey="Savings"
                      stackId="a"
                      fill="#6EA57C"
                      barSize={20}
                    />
                    <Bar
                      dataKey="Cost"
                      stackId="a"
                      fill="#E8BF67"
                      barSize={20}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RecommendationsIndvidualBarGraph;
